import { Meeting } from "../../../../features/Meeting";
import { MeetingsPage } from "../../../../pages/MeetingsPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const meetingsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.meetings.root,
  element: <MeetingsPage />,
  name: "Встречи",
  children: appRouterPaths.meetings.item
    ? [
        {
          path: appRouterPaths.meetings.item,
          element: <Meeting />,
          name: "Встреча",
        },
      ]
    : undefined,
};
